import { useParams }                  from 'react-router-dom'
import {
  Box, Button, Checkbox,
  Container, FormControlLabel, Grid,
  Stack, Typography
}                                     from '@mui/material'
import Page                           from '../ui/components/Page'
import { useTranslation }             from 'react-i18next'
import { useSnackbar }                from 'notistack'
import React, { useEffect, useState } from 'react'
import { useApi }                     from '../utils/api'
import { BaseBreadcrumbs }            from '../ui/components/BaseBreadcrumbs'
import { DateTime }                   from 'luxon'
import ShortFormControl               from '../ui/components/short-form-control'
import { downloadBlob }               from '../utils/utils'

export default function ServiceMessageInputExportPage() {

  const api = useApi()
  const { serviceId } = useParams()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const [service, setService] = useState(null)
  const [values, setValues] = useState({
    dateFrom: DateTime.now().toFormat('yyyy-MM-dd'),
    dateTo: DateTime.now().toFormat('yyyy-MM-dd'),
    onlyCorrect: false
  })

  useEffect(() => {
    if (!isNaN(serviceId)) {
      api.service.detail(serviceId).then(data => setService(data)).catch(e => console.error(e))
    }
  }, [serviceId])

  const onExportSubmit = async (e) => {
    e.preventDefault()
    try {
      const dateFrom = values.dateFrom?.replaceAll('-','')
      const dateTo = values.dateTo?.replaceAll('-','')
      const csvBlob = await api.messageInput.export(serviceId, dateFrom, dateTo, values.onlyCorrect ? 1 : 0)
      downloadBlob(csvBlob, `${service?.title ?? 'export'}-${dateFrom}_${dateTo}.csv`)
    } catch (e) {
      enqueueSnackbar(t('Failed to export'), { variant: 'error' })
    }
  }
  const handleChangeDirect = (prop, value) => {
    setValues((prev) => ({
      ...prev,
      [prop]: value
    }))
  }

  return (<Page title={t('Export customer answers')}>
    <Container>
      <BaseBreadcrumbs key={'breadcrumb-customer-answers'} //message inputs
                       title={t('Export customer answers')}
                       items={[
                         { title: t('Services'), href: `/services` },
                         { title: service?.title ?? t('Service'), href: `/services/${serviceId}` }
                       ]}/>
      <Grid container>
        <Grid item xs={12}>
          <Stack direction={'row'} spacing={2} alignItems={'baseline'} mb={2}>
            <Typography variant={'h6'}>{t('Export customer answers')}</Typography>
            <Box flexGrow={1}/>
          </Stack>
        </Grid>
      </Grid>
      <Grid container component={'form'} onSubmit={onExportSubmit} spacing={2} rowSpacing={2} direction={'row'} alignItems={'flex-end'} justifyContent={'flex-end'} mb={2}>
        <Grid item xs={6} sm={'auto'}>
          <ShortFormControl title={t('From')} handleChange={(name) => (e) => { setValues((prev) => ({
            ...prev,
            dateFrom: e.target?.value
          })) }} value={values.dateFrom} name={'from'} inputProps={{ type: 'date' }} />
        </Grid>
        <Grid item xs={6} sm={'auto'}>
          <ShortFormControl title={t('To')} handleChange={(name) => (e) => { setValues((prev) => ({
            ...prev,
            dateTo: e.target?.value
          })) }} value={values.dateTo} name={'to'} inputProps={{ type: 'date' }} />
        </Grid>
        <Grid item xs={6} sm={'auto'}>
          <FormControlLabel control={<Checkbox/>} checked={values.onlyCorrect} onChange={(e) => {
            handleChangeDirect('onlyCorrect', e.target.checked)
          }} label={t('Only correct')}/>
        </Grid>
        <Grid item xs={12} sx={{ maxWidth: { sm: '200px' } }}>
          <Button fullWidth type={'submit'} variant="outlined">{t('Export')}</Button>
        </Grid>
      </Grid>
    </Container>
  </Page>)
}